module.exports = __webpack_public_path__ + "assets/setting-role.beae899d.svg";